module.exports = __webpack_public_path__ + "img/icon-taxonomy.8f362bbc.svg";